'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactDom = require('react-dom');

var _reactDom2 = _interopRequireDefault(_reactDom);

var _jquery = require('jquery');

var _jquery2 = _interopRequireDefault(_jquery);

require('../css/TariffingPointsToProduct.css');

var _AutocompleteField = require('./AutocompleteField');

var _AutocompleteField2 = _interopRequireDefault(_AutocompleteField);

var _Textfield = require('./Textfield');

var _Textfield2 = _interopRequireDefault(_Textfield);

var _SelectField = require('./SelectField');

var _SelectField2 = _interopRequireDefault(_SelectField);

var _MessageBox = require('./MessageBox');

var _MessageBox2 = _interopRequireDefault(_MessageBox);

var _Icon = require('./Icon');

var _Icon2 = _interopRequireDefault(_Icon);

var _Loading = require('./Loading');

var _Loading2 = _interopRequireDefault(_Loading);

var _Vas = require('../Vas');

var _Vas2 = _interopRequireDefault(_Vas);

var _modelsLib = require('models-lib');

var _utilsLib = require('utils-lib');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var moment = require('moment');
moment().format();

var TariffingPointsToProduct = function (_Component) {
  _inherits(TariffingPointsToProduct, _Component);

  //#region Komponente
  function TariffingPointsToProduct(props) {
    _classCallCheck(this, TariffingPointsToProduct);

    var _this = _possibleConstructorReturn(this, (TariffingPointsToProduct.__proto__ || Object.getPrototypeOf(TariffingPointsToProduct)).call(this, props));

    _this.state = {};

    _this.contractStartInput = _react2.default.createRef();
    _this.priceInput = _react2.default.createRef();
    _this.fromInput = _react2.default.createRef();
    _this.toInput = _react2.default.createRef();
    _this.tariffAreaInput = _react2.default.createRef();
    _this.tariffProductInput = _react2.default.createRef();
    _this.contractEndInput = _react2.default.createRef();

    _this.required = _this.props.Required !== undefined && _this.props.Required !== null ? _this.props.Required : true;
    _this.TimeOutTime = _this.props.TimeOutTime ? _this.props.TimeOutTime : 1000;

    _this.ApplicationUrl = _this.props.ApplicationUrl;
    _this.ApiKey = _this.props.ApiKey;
    _this.ApiUrl = _this.props.ApiUrl;

    _this.allFilled = _this.required === true ? false : true;
    _this.first = null;

    _this.Text = _this.props.Text ? _this.props.Text : "";

    _this.Request = new _modelsLib.RequestAjaxClass(function (error) {
      _this.props.ErrorHandling ? _this.props.ErrorHandling(error) : '';
    }, null);
    _this.Request2 = new _modelsLib.RequestAjaxClass(function (error) {
      _this.props.ErrorHandling(error) ? _this.props.ErrorHandling(error) : '';
    }, null);

    _this.ContractStartParamsModel = new _modelsLib.ContractStartParamsModel([_this], null, _this.Request);
    _this.TariffPointsModelFrom = new _modelsLib.TariffPointsModel([_this], "TariffPointFrom", _this.Request);
    _this.TariffPointsModelTo = new _modelsLib.TariffPointsModel([_this], "TariffPointTo", _this.Request2);
    _this.TariffProductsModel = new _modelsLib.TariffProductsModel([_this], null, _this.Request2);
    _this.MultimediaTextModel = new _modelsLib.MultimediaTextModel([_this], null, _this.Request);

    _this.Tariff = localStorage.getItem('Tariff') !== null && localStorage.getItem('Tariff') !== undefined ? JSON.parse(localStorage.getItem('Tariff')) : null;

    //soll das Vertragsendedatum angezeigt werden
    _this.ShowContractEnd = _this.props.ShowContractEnd !== null && _this.props.ShowContractEnd !== undefined ? _this.props.ShowContractEnd : true;
    //wie viele Monate in der Zukunft sollen die Vertragsbeginndaten anfangen
    _this.ContractStartMonthsInFuture = _this.props.ContractStartMonthsInFuture !== null && _this.props.ContractStartMonthsInFuture !== undefined ? _this.props.ContractStartMonthsInFuture : 0;

    _this.ContractEndText = _this.props.ContractEndText ? _this.props.ContractEndText : _Vas2.default.getText("Labels", "ContractEnd");

    return _this;
  }

  _createClass(TariffingPointsToProduct, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _this2 = this;

      this.Request.setAuth(false);
      this.Request.setApiKey(this.ApiKey);
      this.Request.setApiUrl(this.ApiUrl);
      this.Request.setErrorHandler(function () {
        (0, _jquery2.default)("#LoadingIconPopUp").removeClass().addClass('hide');
      });

      this.Request2.setAuth(false);
      this.Request2.setApiKey(this.ApiKey);
      this.Request2.setApiUrl(this.ApiUrl);
      this.Request2.setErrorHandler(function () {
        (0, _jquery2.default)("#LoadingIconPopUp").removeClass().addClass('hide');
      });

      this.ContractStartParamsModel.GetContractStartParams();

      this.setState({ requiredFields: [{ Key: this.fromInput.current, Index: 2, Step: 1 }, { Key: this.toInput.current, Index: 3, Step: 1 }],
        requiredSelectField: [{ Key: this.contractStartInput.current, Index: 1, Step: 1 }, { Key: this.tariffAreaInput.current, Index: 4, Step: 1 }, { Key: this.tariffProductInput.current, Index: 5, Step: 1 }] }, function () {

        _utilsLib.SetRequired.Set(_this2.state.requiredFields, _this2.state.requiredSelectField);
      });
    }
  }, {
    key: 'Update',
    value: function Update(observer) {
      var _this3 = this;

      var me = this;
      this.setState({}, function () {
        if (observer === "ContractStartParams") {
          var day = '';
          var months = 0;
          day = me.ContractStartParamsModel.DayBeginAfterNextMonth;
          months = me.ContractStartParamsModel.MonthBeginInFuture;
          var today = moment();
          var dateArr = [];

          if (months === 0) {
            var date = moment([today.year(), today.month(), 1]).add(1, 'M').format("DD.MM.YYYY");
            if (localStorage.getItem('vas_language') === 'en') {
              date = moment([today.year(), today.month(), 1]).add(1, 'M').format("MM/DD/YYYY");
            }
            dateArr.push({ Key: date, Display: date });
          } else {
            for (var i = 0; i < months; i++) {
              var month = '';
              var year = today.year();

              if (day == '0' || today.date() <= day) {
                month = today.month() + i + _this3.ContractStartMonthsInFuture;
              } else {
                month = today.month() + i + 1 + _this3.ContractStartMonthsInFuture;
              }

              if (month > 11) {
                var cur = month - 11;
                month = -1 + cur;
                year += 1;
              }

              var _date = moment([year, month, 1]).format("DD.MM.YYYY");

              if (localStorage.getItem('vas_language') === 'en') {
                _date = moment([year, month, 1]).format("MM/DD/YYYY");
              }
              dateArr.push({ Key: _date, Display: _date });
            }
          }
          if (me.contractStartInput) {
            if (me.contractStartInput.current) {
              me.contractStartInput.current.setState({ Data: dateArr }, function () {
                _this3.setTariff("ContractStart", dateArr);
              });
            }
          }
        } else if (observer === "TariffPointFrom") {
          var result = me.TariffPointsModelFrom.TariffPoints;
          var resultArr = [];
          result.forEach(function (e) {
            resultArr.push(e.DescriptionLong);
          });

          if (me.fromInput.current) {
            me.fromInput.current.setState({ Data: resultArr, Loading: false, Icon: 'Close' }, function () {
              _this3.setTariff("From");
            });
          }
        } else if (observer === "TariffPointTo") {
          var _result = me.TariffPointsModelTo.TariffPoints;
          var _resultArr = [];
          _result.forEach(function (e) {
            _resultArr.push(e.DescriptionLong);
          });

          if (me.toInput.current) {
            me.toInput.current.setState({ Data: _resultArr, Loading: false, Icon: 'Close' });
          }

          _this3.setTariff("To");
        } else if (observer === "TariffProducts") {
          (0, _jquery2.default)("#LoadingIconPopUp").removeClass().addClass('hide');
          var data = me.TariffProductsModel.ProductList;
          var vias = [];

          for (var _i = 0; _i < data.length; _i++) {

            var relation = data[_i].TzViaText2;
            var idTicket = data[_i].IdTicket;
            var traversedZones = data[_i].TraversedZones !== null ? data[_i].TraversedZones : [];

            if (traversedZones.length > 0 && traversedZones[0]) {

              var viaSplit = data[_i].TzViaText2.split("(");
              var viatext = viaSplit[0] + "(" + data[_i].IdendTzVia + ")";
              var via = { Key: data[_i].Price + ";" + data[_i].PaymentInterval + ";" + relation + ";" + idTicket, Display: viatext };
              var consist = false;
              if (vias.length >= 1) {
                for (var j = 0; j < vias.length; j++) {
                  if (vias[j].Display === viatext) {
                    var viaArr = vias[j].Key.split(';');
                    if (viaArr[2] === relation) {
                      consist = true;
                      break;
                    }
                  }
                }
              }

              if (consist === false) {
                vias.push(via);
              }
            }
          }

          me.tariffAreaInput.current.setState({ Data: vias, Loading: false }, function () {
            _this3.setTariff("Product", vias);
          });
        }
      });
    }
  }, {
    key: 'setTariff',
    value: function setTariff(field, dataArray) {
      var _this4 = this;

      var me = this;
      if (this.Tariff !== null && this.Tariff !== undefined) {
        if (field === "ContractStart") {
          _reactDom2.default.render(_react2.default.createElement(_Loading2.default, { modal: true }), document.getElementById('popupContainer'));

          var idx = 0;
          var contractStart = _utilsLib.DateTimeHelper.FormatToShortDateString(_utilsLib.DateTimeHelper.StringToDate(this.Tariff[1].ContractStart, true, localStorage.getItem('vas_language')));
          for (var i = 0; i < dataArray.length; i++) {
            if (dataArray[i].Display === contractStart) {
              idx = i + 1;
            }
          }

          document.getElementById('ContractStart').selectedIndex = idx;

          this.setState({ ContractStart: contractStart });
          this.TariffPointsModelFrom.GetTariffPoints(this.Tariff[1].DescriptionShort, this.Tariff[1].ContractStart);
          (0, _jquery2.default)('#From').val(this.Tariff[1].DescriptionLong);
          //--> geht weiter in Update(observer):TariffPointsFrom
        } else if (field === "From") {
          this.TariffPointsModelFrom.SelectedTariffId = this.GetTariffPointOfArray(document.getElementById('From').value, this.TariffPointsModelFrom.TariffPoints);

          this.TariffPointsModelTo.GetTariffPoints(this.Tariff[2].DescriptionShort, this.Tariff[2].ContractStart);
          (0, _jquery2.default)('#To').val(this.Tariff[2].DescriptionLong);

          //--> geht weiter in Update(observer):TariffPointTo
        } else if (field === "To") {
          this.Request2.setErrorHandler(function () {
            (0, _jquery2.default)("#LoadingIconPopUp").removeClass().addClass('hide');
          });

          (0, _jquery2.default)("#LoadingIconPopUp").removeClass().addClass('loaderSmall');
          var x = document.getElementsByClassName("autocomplete-items");
          for (var _i2 = 0; _i2 < x.length; _i2++) {
            x[_i2].parentNode.removeChild(x[_i2]);
          }
          this.TariffPointsModelTo.SelectedTariffId = this.GetTariffPointOfArray(document.getElementById('To').value, this.TariffPointsModelTo.TariffPoints);

          this.TariffProductsModel.GetTariffProducts(this.TariffPointsModelFrom.TariffPoints[0], this.TariffPointsModelTo.TariffPoints[0]);
          //--> geht weiter in Update(observer): TariffProducts
        } else if (field === "Product") {
          var _idx = 0;
          for (var _i3 = 0; _i3 < dataArray.length; _i3++) {
            if (dataArray[_i3].Key.split(";")[2] === this.Tariff[0].TzViaText2) {
              _idx = _i3;
            }
          }
          this.setState({ Via: dataArray[_idx].Key }, function () {
            document.getElementById("Via").selectedIndex = _idx + 1;

            var via = _this4.state.Via;
            var viaArr = via.split(';');
            var relation = viaArr[2];
            var idTicket = viaArr[3];
            var products = [];
            for (var _i4 = 0; _i4 < _this4.TariffProductsModel.ProductList.length; _i4++) {

              var data = _this4.TariffProductsModel.ProductList[_i4];
              if (data.TzViaText2 === relation) {
                var product = { Key: data.Price + ";" + data.PaymentInterval + ";" + data.IdTicket + ";" + data.ContractEnd, Display: data.TicketName };
                products.push(product);

                if (data.IdTicket === idTicket) {
                  _this4.showTraversedZones(data.TraversedZones);
                }
              }
            }
            _this4.tariffProductInput.current.setState({ Data: products }, function () {
              _idx = 0;
              for (var _i5 = 0; _i5 < products.length; _i5++) {
                if (products[_i5].Display === _this4.Tariff[0].TicketName) {
                  _idx = _i5;
                }
              }
              document.getElementById('Product').selectedIndex = _idx + 1;

              _this4.setPriceAndContractEnd();
              _this4.setVisible("setTariff");
              _reactDom2.default.unmountComponentAtNode(document.getElementById('popupContainer'));
            });
          });
        }
      }
    }
  }, {
    key: 'setVisible',
    value: function setVisible(field) {

      if (field === "ContractStart") {
        this.TariffProductsModel.ProductList = [];
        this.tariffProductInput.current.setState({ Data: [] });
        (0, _jquery2.default)('#From').val('');
        (0, _jquery2.default)('#To').val('');
        this.fromInput.current.setState({ Data: [], editable: true });
        this.toInput.current.setState({ Data: [], editable: false });
        this.tariffAreaInput.current.setState({ Icon: "", Data: null, editable: false });
        this.removePriceAndContractEnd();
        this.removeTraversedZones();
      } else if (field === "From") {
        this.TariffProductsModel.ProductList = [];
        this.tariffProductInput.current.setState({ Data: [] });
        (0, _jquery2.default)('#To').val('');
        this.toInput.current.setState({ Data: [], editable: true });
        this.tariffAreaInput.current.setState({ Icon: "", Data: null, editable: false });
        this.removePriceAndContractEnd();
        this.removeTraversedZones();
      } else if (field === "To") {
        this.TariffProductsModel.ProductList = [];
        this.tariffProductInput.current.setState({ Data: [] });
        this.tariffAreaInput.current.setState({ Icon: "", Data: null, editable: false });
        this.removePriceAndContractEnd();
        this.removeTraversedZones();
      } else if (field === "setTariff") {
        this.fromInput.current.setState({ editable: true });
        this.toInput.current.setState({ editable: true });
      }
    }

    //#endregion

    //#region check Fields

  }, {
    key: 'checkFields',
    value: function checkFields() {
      //überprüft Pflichtfelder, ob geprüft

      if (this.state.requiredFields && this.state.requiredSelectField) {
        var filled = false;
        filled = _utilsLib.CheckFields.CheckFields(this.state.requiredFields, this.state.requiredSelectField);
        return filled;
      }
    }
    //#endregion

    //#region TariffPoints

  }, {
    key: 'GetTariffPointOfArray',
    value: function GetTariffPointOfArray(tariffPoint, tariffPoints) {
      var idx = -1;
      for (var i = 0; i < tariffPoints.length; i++) {
        if (tariffPoint === tariffPoints[i].DescriptionLong) {
          idx = i;
        }
      }
      return idx;
    }
  }, {
    key: 'Search',
    value: function Search(field) {
      //Suche nach TariffPoint nach Eingabe von mind 3 Zeichen und einer Wartezeit von 1s
      var me = this;
      if ((0, _jquery2.default)("#" + field).val().length >= 3) {

        this.TimeOut = window.setTimeout(function () {
          me.GetStation((0, _jquery2.default)("#" + field).val(), field);
        }, this.TimeOutTime);
      } else {
        if ((0, _jquery2.default)("#" + field).val().length === 0) {
          this.tariffAreaInput.current.setState({ Data: null });
          this.removePriceAndContractEnd();
        }
      }
    }
  }, {
    key: 'GetStation',
    value: function GetStation(search, id) {
      //Suche des TariffPoint
      if (id === "From") {
        this.fromInput.current.setState({ Loading: true, Icon: null });
      } else if (id === "To") {
        this.toInput.current.setState({ Loading: true, Icon: null });
      }

      var curContractStart = _utilsLib.DateTimeHelper.StringToDate(this.state.ContractStart, false, localStorage.getItem('vas_language'));

      if (id === "From") {
        this.TariffPointsModelFrom.GetTariffPoints(search, moment([curContractStart.year(), curContractStart.month(), curContractStart.date()]).format("YYYY-MM-DD T 00:00:00"));
      } else if (id === "To") {
        this.TariffPointsModelTo.GetTariffPoints(search, moment([curContractStart.year(), curContractStart.month(), curContractStart.date()]).format("YYYY-MM-DD T 00:00:00"));
      }
    }
  }, {
    key: 'checkPoint',
    value: function checkPoint(field) {
      //nach Verlassen des Feldes mit TariffPoint, prüfen, ob ein gültiger TariffPoint ausgewählt wurde

      var val = (0, _jquery2.default)('#' + field).val();
      var valid = true;
      if (val.length > 0) {
        valid = false;
        var values = [];
        if (field === "From") {
          values = this.TariffPointsModelFrom.TariffPoints;
        } else if (field === "To") {
          values = this.TariffPointsModelTo.TariffPoints;
        }

        if (values.length > 0) {
          for (var i = 0; i < values.length; i++) {
            if (values[i].DescriptionLong === val) {
              valid = true;
              break;
            }
          }
        }
        if (valid === false) {
          _reactDom2.default.render(_react2.default.createElement(_MessageBox2.default, {
            AppURL: this.ApplicationUrl,
            Title: _Vas2.default.getText("Titles", "Error"),
            Message: _Vas2.default.getText("Labels", "FalseProduct"),
            Click: this.resetField(field) }), document.getElementById('messageContainer'));
        }
      }
      return valid;
    }

    //#endregion

    //#region TariffProducts

  }, {
    key: 'GetVia',
    value: function GetVia() {
      var _this5 = this;

      //suche TariffProduct

      this.tariffAreaInput.current.setState({ Data: null }, function () {

        if (_this5.TariffPointsModelFrom.TariffPoints && _this5.TariffPointsModelFrom.SelectedTariffId > -1 && _this5.TariffPointsModelTo.TariffPoints && _this5.TariffPointsModelTo.SelectedTariffId > -1) {
          _this5.tariffAreaInput.current.setState({ Loading: true }, function () {
            _this5.removePriceAndContractEnd();
            _this5.removeTraversedZones();
            (0, _jquery2.default)("#LoadingIconPopUp").removeClass().addClass('loaderSmall');
            _this5.TariffProductsModel.GetTariffProducts(_this5.TariffPointsModelFrom.TariffPoints[_this5.TariffPointsModelFrom.SelectedTariffId], _this5.TariffPointsModelTo.TariffPoints[_this5.TariffPointsModelTo.SelectedTariffId]);
          });
        } else {
          (0, _jquery2.default)("#LoadingIconPopUp").removeClass().addClass('hide');
        }
      });
    }
  }, {
    key: 'setVia',
    value: function setVia() {
      //nach Auswahl eines TariffPoint setzte alle Werte für diesen
      this.setPriceAndContractEnd();
      if ((0, _jquery2.default)("#Product").val() && (0, _jquery2.default)("#Product").val().length > 0) {
        var product = (0, _jquery2.default)("#Product").val().split(';');
        var productId = product[2];
        for (var i = 0; i < this.TariffProductsModel.ProductList.length; i++) {
          if (productId === this.TariffProductsModel.ProductList[i].IdTicket) {
            this.setState({ ViaRoute: this.TariffProductsModel.ProductList[i] });
          }
        }
      }
    }
  }, {
    key: 'getProducts',
    value: function getProducts() {
      var _this6 = this;

      if (document.getElementById('Via').selectedIndex > 0) {
        if (this.TariffProductsModel.ProductList) {

          this.tariffProductInput.current.setState({ Icon: "Loop" }, function () {
            var via = _this6.state.Via;
            var viaArr = via.split(';');

            var relation = viaArr[2];
            var idTicket = viaArr[3];
            var products = [];

            for (var i = 0; i < _this6.TariffProductsModel.ProductList.length; i++) {

              var data = _this6.TariffProductsModel.ProductList[i];
              if (data.TzViaText2 === relation) {
                var product = { Key: data.Price + ";" + data.PaymentInterval + ";" + data.IdTicket + ";" + data.ContractEnd, Display: data.TicketName };
                products.push(product);

                if (data.IdTicket === idTicket) {
                  _this6.showTraversedZones(data.TraversedZones);
                }
              }
            }

            _this6.tariffProductInput.current.setState({ Data: products, Icon: null }, function () {
              _this6.removePriceAndContractEnd();
              if (_this6.Tariff !== null && _this6.Tariff !== undefined) {

                var idx = 0;
                for (var _i6 = 0; _i6 < products.length; _i6++) {
                  if (products[_i6].Display === _this6.Tariff[0].TicketName) {
                    idx = _i6;
                  }
                }
                document.getElementById('Product').selectedIndex = idx + 1;

                _reactDom2.default.unmountComponentAtNode(document.getElementById('popupContainer'));

                _this6.setVia();
              }
            });
          });
        }
      }
    }
    //#endregion

    //#region price and contract end

  }, {
    key: 'setPriceAndContractEnd',
    value: function setPriceAndContractEnd() {
      //holt Preis des gewählten TariffProducts und gibt diesen aus

      if (document.getElementById("Product").selectedIndex > 0) {

        var priceInfoArr = (0, _jquery2.default)("#Product").val().split(';');

        this.SetPaymentIntervall(priceInfoArr[1]);

        this.priceInput.current.setState({ Value: _utilsLib.CurrencyConverter.Cast(priceInfoArr[0], localStorage.getItem('vas_language'), 2) });

        if (this.ShowContractEnd === true) {
          this.contractEndInput.current.setState({ Value: priceInfoArr[3] !== 'null' ? _utilsLib.DateTimeHelper.FormatToShortDateString(_utilsLib.DateTimeHelper.StringToDate(priceInfoArr[3], true, localStorage.getItem('vas_language'))) : _Vas2.default.getText('Labels', 'Unlimited') });
        }
      } else {
        this.priceInput.current.setState({ Value: '' });
        if (this.ShowContractEnd === true) {
          this.contractEndInput.current.setState({ Value: '' });
        }
      }
    }
  }, {
    key: 'SetPaymentIntervall',
    value: function SetPaymentIntervall(paymentIntervall) {
      var priceInfoDefault = " " + _Vas2.default.getText("Labels", "inEuro");
      var priceInfo = '';

      switch (paymentIntervall) {
        case "1":
          priceInfo = _Vas2.default.getText("Labels", "WeeklyPrice") + " " + priceInfoDefault;
          break;
        case "2":
          priceInfo = _Vas2.default.getText("Labels", "BiweeklyPrice") + " " + priceInfoDefault;
          break;
        case "3":
        default:
          priceInfo = _Vas2.default.getText("Labels", "MonthlyPrice") + " " + priceInfoDefault;
          break;
        case "4":
          priceInfo = _Vas2.default.getText("Labels", "QuarterlyPrice") + " " + priceInfoDefault;
          break;
        case "5":
          priceInfo = _Vas2.default.getText("Labels", "SemiannualPrice") + " " + priceInfoDefault;
          break;
        case "6":
          priceInfo = _Vas2.default.getText("Labels", "AnnualPrice") + " " + priceInfoDefault;
          break;
      }

      this.priceInput.current.setState({ Label: priceInfo });
    }
  }, {
    key: 'removePriceAndContractEnd',
    value: function removePriceAndContractEnd() {
      //Aufruf, wenn To in Preisinformation zuvor gecleared wurde
      (0, _jquery2.default)("#Price").val('');
      this.priceInput.current.setState({ Value: '', Label: _Vas2.default.getText("Labels", "ProductPrice") + " " + _Vas2.default.getText("Labels", "inEuro") });
      if (this.ShowContractEnd === true) {
        if (this.contractEndInput.current !== null && this.contractEndInput !== undefined) {
          (0, _jquery2.default)("#ContractEnd").val('');
          this.contractEndInput.current.setState({ Value: '' });
        }
      }
    }

    //#endregion

    //#region traversed zones

  }, {
    key: 'showTraversedZones',
    value: function showTraversedZones(traversedZones) {
      var _this7 = this;

      this.removeTraversedZones();

      if (traversedZones !== null && traversedZones !== undefined) {

        var Zones = [];
        var Waben = [];
        for (var i = 0; i < traversedZones.length; i++) {
          //Waben.push(traversedZones[i].Description.substring(0,1).toUpperCase() + traversedZones[i].Description.substring(1).toLowerCase());
          Waben.push(traversedZones[i].Description);
        }
        Waben.sort();

        for (var _i7 = 0; _i7 < Waben.length; _i7++) {
          var zone = _react2.default.createElement(
            'div',
            { key: _i7 },
            Waben[_i7]
          );
          Zones.push(zone);
        }

        if (Waben.length > 0) {
          (0, _jquery2.default)('#TraversedZonesArea').removeClass().addClass('display');

          _reactDom2.default.render(_react2.default.createElement(
            'div',
            null,
            _react2.default.createElement('br', null),
            _react2.default.createElement(
              'div',
              null,
              _react2.default.createElement(
                'div',
                {
                  id: "TraversedZones",
                  className: "TicketBoxTitle",
                  onClick: function onClick() {
                    _this7.ToggleDetails('TraversedZones');
                  } },
                _react2.default.createElement(
                  'div',
                  {
                    id: "KeyboardArrowRightKontakt",
                    className: "Show" },
                  _react2.default.createElement(_Icon2.default, {
                    Name: "KeyboardArrowRight",
                    Size: 36,
                    Color: "black",
                    Align: "left" })
                ),
                _react2.default.createElement(
                  'div',
                  {
                    id: "KeyboardArrowDownKontakt",
                    className: "Hide" },
                  _react2.default.createElement(_Icon2.default, {
                    Name: "KeyboardArrowDown",
                    Size: 36,
                    Color: "black",
                    Align: "left" })
                ),
                _react2.default.createElement(
                  'div',
                  { style: { paddingTop: '1px' } },
                  _Vas2.default.getText("Labels", "TraversedZones")
                )
              ),
              _react2.default.createElement(
                'div',
                {
                  id: "TraversedZonesDetails",
                  className: "Hide" },
                _react2.default.createElement(
                  'div',
                  { className: "TicketBoxText" },
                  _react2.default.createElement(
                    'table',
                    null,
                    _react2.default.createElement(
                      'tbody',
                      null,
                      _react2.default.createElement(
                        'tr',
                        null,
                        _react2.default.createElement(
                          'td',
                          null,
                          Zones
                        )
                      )
                    )
                  )
                )
              )
            ),
            _react2.default.createElement('br', null)
          ), document.getElementById('TraversedZonesArea'));
        }
      }
    }
  }, {
    key: 'removeTraversedZones',
    value: function removeTraversedZones(id) {
      if (document.getElementById('TraversedZonesArea')) {
        //ReactDOM.unmountComponentAtNode(document.getElementById('TraversedZones'));
        (0, _jquery2.default)('#TraversedZonesArea').removeClass().addClass('hide');
      }
    }
  }, {
    key: 'ToggleDetails',
    value: function ToggleDetails(id) {

      if ((0, _jquery2.default)("#" + id + "Details").hasClass('Show')) {
        (0, _jquery2.default)("#" + id + "Details").removeClass().addClass('Hide');

        (0, _jquery2.default)("#KeyboardArrowRight" + id).removeClass().addClass('Show');

        (0, _jquery2.default)("#KeyboardArrowDown" + id).removeClass().addClass('Hide');
      } else {
        (0, _jquery2.default)("#" + id + "Details").removeClass().addClass('Show');

        (0, _jquery2.default)("#KeyboardArrowRight" + id).removeClass().addClass('Hide');

        (0, _jquery2.default)("#KeyboardArrowDown" + id).removeClass().addClass('Show');
      }
    }
    //#endregion

  }, {
    key: 'returnTariffProduct',
    value: function returnTariffProduct() {
      if (document.getElementById("Product").selectedIndex > 0) {
        var product = (0, _jquery2.default)("#Product").val().split(';');
        var productId = product[2];
        var via = '';
        for (var i = 0; i < this.TariffProductsModel.ProductList.length; i++) {
          if (this.TariffProductsModel.ProductList[i].IdTicket === productId) {
            via = this.TariffProductsModel.ProductList[i];
            break;
          }
        }

        var from = this.TariffProductsModel.TariffPointFrom;
        var to = this.TariffProductsModel.TariffPointTo;
        var tariff = [via, from, to];
        localStorage.setItem("Tariff", JSON.stringify(tariff));
        return tariff;
      } else {
        return [null, null, null];
      }
    }
  }, {
    key: 'returnFilled',
    value: function returnFilled() {
      return [this.allFilled, this.first];
    }
  }, {
    key: 'returnFields',
    value: function returnFields() {
      return [this.contractStartInput, this.fromInput, this.toInput, this.tariffAreaInput, this.tariffProductInput, this.priceInput];
    }
  }, {
    key: 'render',
    value: function render() {
      var _this8 = this;

      var fields = _react2.default.createElement(
        'tr',
        null,
        _react2.default.createElement(
          'td',
          null,
          _react2.default.createElement(
            'table',
            null,
            _react2.default.createElement(
              'tbody',
              null,
              _react2.default.createElement(
                'tr',
                null,
                _react2.default.createElement(
                  'td',
                  null,
                  _react2.default.createElement(
                    'div',
                    { style: { color: '#797979', fontSize: '15px', width: '50px', marginTop: '4px', fontWeight: 'bold' } },
                    _Vas2.default.getText("Labels", "From")
                  ),
                  _react2.default.createElement(
                    'div',
                    null,
                    _react2.default.createElement(_AutocompleteField2.default, {
                      Autocomplete: false,
                      AppURL: this.ApplicationUrl,
                      editable: false,
                      ref: this.fromInput,
                      Id: "From",
                      Modus: "TariffPoint",
                      IsRequired: true,
                      Width: '100%',
                      Label: _Vas2.default.getText("Labels", "FromAddition"),
                      PriceInfoText: _Vas2.default.getText("Labels", "ProductPrice") + " " + _Vas2.default.getText("Labels", "inEuro"),
                      TimeOutTime: this.TimeOutTime,
                      ClearFunction: function ClearFunction() {
                        _this8.TariffPointsModelFrom.TariffPoints = [];

                        _this8.TariffProductsModel.TariffProducts = [];

                        _this8.setVisible("ContractStart");

                        localStorage.removeItem('Tariff');
                        _this8.Tariff = null;
                        _this8.removeTraversedZones();
                      },
                      OnIconClick: function OnIconClick() {
                        _this8.Search("From");
                      },
                      OnChange: function OnChange() {
                        _this8.Search("From");
                      },
                      Function: function Function() {
                        _this8.TariffPointsModelFrom.SelectedTariffId = _this8.GetTariffPointOfArray(document.getElementById('From').value, _this8.TariffPointsModelFrom.TariffPoints);
                        _this8.setVisible("From");
                      },
                      TitleMessageFalseStreet: _Vas2.default.getText("Labels", "Error"),
                      MessageFalseStreet: _Vas2.default.getText("Labels", "FalseProduct")
                    })
                  )
                )
              ),
              _react2.default.createElement(
                'tr',
                null,
                _react2.default.createElement(
                  'td',
                  null,
                  _react2.default.createElement(
                    'div',
                    { style: { color: '#797979', fontSize: '15px', width: '50px', marginTop: '4px', fontWeight: 'bold' } },
                    _Vas2.default.getText("Labels", "To")
                  ),
                  _react2.default.createElement(
                    'div',
                    null,
                    _react2.default.createElement(_AutocompleteField2.default, {
                      Autocomplete: false,
                      AppURL: this.ApplicationUrl,
                      editable: false,
                      ref: this.toInput,
                      Id: "To",
                      Modus: "TariffPoint",
                      Float: 'left',
                      IsRequired: true,
                      Width: '100%',
                      Label: _Vas2.default.getText("Labels", "FromAddition"),
                      PriceInfoText: _Vas2.default.getText("Labels", "ProductPrice") + " " + _Vas2.default.getText("Labels", "inEuro"),
                      TimeOutTime: this.TimeOutTime,
                      ClearFunction: function ClearFunction() {
                        _this8.TariffPointsModelTo.TariffPoints = [];

                        _this8.TariffProductsModel.TariffProducts = [];

                        _this8.setVisible("From");

                        localStorage.removeItem('Tariff');
                        _this8.Tariff = null;
                        _this8.removeTraversedZones("To");
                      },
                      OnIconClick: function OnIconClick() {
                        _this8.Search("To");
                      },
                      OnChange: function OnChange() {
                        _this8.Search("To");
                      },
                      Function: function Function() {
                        _this8.TariffPointsModelTo.SelectedTariffId = _this8.GetTariffPointOfArray(document.getElementById('To').value, _this8.TariffPointsModelTo.TariffPoints);
                        _this8.GetVia();
                        _this8.setVisible("To");
                      },
                      TitleMessageFalseStreet: _Vas2.default.getText("Labels", "Error"),
                      MessageFalseStreet: _Vas2.default.getText("Labels", "FalseProduct")
                    })
                  )
                )
              ),
              _react2.default.createElement(
                'tr',
                null,
                _react2.default.createElement(
                  'td',
                  null,
                  _react2.default.createElement(
                    'div',
                    null,
                    _react2.default.createElement(_SelectField2.default, {
                      AppURL: this.ApplicationUrl,
                      ref: this.tariffAreaInput,
                      Id: "Via",
                      IsRequired: true,
                      Label: _Vas2.default.getText("Labels", "TariffArea"),
                      LabelHeight: '15px',
                      PriceInfoText: _Vas2.default.getText("Labels", "ProductPrice") + " " + _Vas2.default.getText("Labels", "inEuro"),
                      OnChange: function OnChange() {
                        _this8.setState({ Via: (0, _jquery2.default)('#Via').val() }, function () {
                          _this8.tariffProductInput.current.setState({ Data: null });
                          _this8.getProducts();
                        });
                      }
                    })
                  )
                )
              ),
              _react2.default.createElement(
                'tr',
                null,
                _react2.default.createElement(
                  'td',
                  null,
                  _react2.default.createElement('div', { id: "TraversedZonesArea" })
                )
              ),
              _react2.default.createElement(
                'tr',
                null,
                _react2.default.createElement(
                  'td',
                  null,
                  _react2.default.createElement(
                    'div',
                    null,
                    _react2.default.createElement(_SelectField2.default, {
                      AppURL: this.ApplicationUrl,
                      ref: this.tariffProductInput,
                      Id: "Product",
                      IsRequired: true,
                      Label: _Vas2.default.getText("Labels", "Product"),
                      PriceInfoText: _Vas2.default.getText("Labels", "ProductPrice") + " " + _Vas2.default.getText("Labels", "inEuro"),
                      OnChange: function OnChange() {
                        _this8.setState({ Product: (0, _jquery2.default)("#Product").val() }, function () {
                          _this8.setPriceAndContractEnd();
                        });
                      }
                    })
                  )
                )
              )
            )
          )
        )
      );

      var contractEndFalse = _react2.default.createElement('div', null);
      var contractEndTrue = _react2.default.createElement('div', null);

      if (this.ShowContractEnd === true) {
        contractEndTrue = _react2.default.createElement(_Textfield2.default, {
          AppURL: this.ApplicationUrl,
          Editable: false,
          ref: this.contractEndInput,
          Id: "ContractEnd",
          Label: this.ContractEndText
        });
      }

      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          'table',
          null,
          _react2.default.createElement(
            'tbody',
            null,
            _react2.default.createElement(
              'tr',
              null,
              _react2.default.createElement(
                'td',
                null,
                _react2.default.createElement(_SelectField2.default, {
                  AppURL: this.ApplicationUrl,
                  ref: this.contractStartInput,
                  Id: "ContractStart",
                  IsRequired: true,
                  Label: _Vas2.default.getText("Labels", "ContractStart"),
                  LabelHeight: '15px',
                  OnChange: function OnChange() {
                    _this8.setState({ ContractStart: (0, _jquery2.default)("#ContractStart").val() }, function () {
                      localStorage.removeItem('Tariff');
                      _this8.Tariff = null;
                      _this8.removeTraversedZones("To");
                      _this8.setVisible("ContractStart");
                    });
                  } })
              ),
              _react2.default.createElement('td', null)
            ),
            _react2.default.createElement(
              'tr',
              null,
              _react2.default.createElement(
                'td',
                null,
                _react2.default.createElement(
                  'div',
                  { id: 'HintContractStart', className: "HintLabel" },
                  this.Text
                )
              )
            ),
            fields,
            _react2.default.createElement(
              'tr',
              null,
              _react2.default.createElement(
                'td',
                { id: "PriceInformation" },
                _react2.default.createElement(_Textfield2.default, {
                  AppURL: this.ApplicationUrl,
                  ref: this.priceInput,
                  Editable: false,
                  Id: "Price",
                  Label: _Vas2.default.getText("Labels", "ProductPrice")
                })
              )
            ),
            _react2.default.createElement(
              'tr',
              null,
              _react2.default.createElement(
                'td',
                null,
                contractEndTrue,
                contractEndFalse
              )
            )
          )
        )
      );
    }
  }]);

  return TariffingPointsToProduct;
}(_react.Component);

exports.default = TariffingPointsToProduct;